// extracted by mini-css-extract-plugin
export default {"custom_toast":"customtoast_custom_toast__P5Glf","success":"customtoast_success__r9qN9"};